import { TRACKING } from '@/lib/tracking';
import { TRACKING_LIMITS, truncateTracking } from './tracking-limits';

/** Attribution a form sends alongside its fields (client-side only). */
export interface TrackingPayload {
  readonly gclid?: string | undefined;
  readonly pageUri: string;
  readonly referrer?: string | undefined;
  readonly landingReferrer?: string | undefined;
  readonly landingUri?: string | undefined;
}

function readCookie(name: string): string | undefined {
  const match = document.cookie.split('; ').find((row) => row.startsWith(`${name}=`));
  return match?.slice(name.length + 1);
}

function readEncodedCookie(name: string): string | undefined {
  const raw = readCookie(name);
  if (!raw) return undefined;
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}

/** The gclid and first-touch cookies the tracking script wrote, plus the page. */
export function readTrackingPayload(): TrackingPayload {
  // Trimmed to the same caps the server applies, so the post stays small.
  return {
    gclid: truncateTracking(readCookie(TRACKING.gclidCookieName), TRACKING_LIMITS.gclid),
    pageUri: window.location.href.slice(0, TRACKING_LIMITS.url),
    referrer: truncateTracking(document.referrer || undefined, TRACKING_LIMITS.url),
    landingReferrer: truncateTracking(
      readEncodedCookie(TRACKING.landingReferrerCookieName),
      TRACKING_LIMITS.url,
    ),
    landingUri: truncateTracking(readEncodedCookie(TRACKING.landingUriCookieName), TRACKING_LIMITS.landingUri),
  };
}
